/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Trips_Delete_TitleInputs */

const en_ui_trips_delete_title = /** @type {(inputs: Ui_Trips_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Trip`)
};

const de_ui_trips_delete_title = /** @type {(inputs: Ui_Trips_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tour löschen`)
};

/**
* | output |
* | --- |
* | "Delete Trip" |
*
* @param {Ui_Trips_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_trips_delete_title = /** @type {((inputs?: Ui_Trips_Delete_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Trips_Delete_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_trips_delete_title(inputs)
	return de_ui_trips_delete_title(inputs)
});